import styled from 'styled-components';
import { css } from 'styled-components';

export const VideoContainer = styled.div`
	gap: 16px;
	padding: 16px;
	display: flex;
	flex-direction: column;
`;

export const VideoPlayer = styled.div`
	width: 100%;
	height: 515px;
	border-radius: 15px;
	overflow: hidden;
	position: relative;
	background: #f0f0f0;
`;

export const VideoThumbnail = styled.div`
	width: 100%;
	height: 100%;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const PlayButton = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	cursor: pointer;
	z-index: 2;
`;

export const InfoItem = styled.div`
	display: flex;
	padding: 16px;
	flex-direction: column;
`;

export const InfoLabel = styled.span`
	${({ theme }) => css`
		${{ ...theme.fonts.heading.sm }}
	`}
`;

export const InfoValue = styled.span`
	font-size: ${({ theme }) => theme.sizes.fonts.fs_sm};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_md};
	letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_lg};
	font-weight: ${({ theme }) => theme.sizes.weights.regular};
`;

export const Divider = styled.div`
	height: 1px;
	background-color: #e6e6e6;
	margin: 16px 0;
	width: 100%;
`;
